export const WebXRMode = {
    None: 0,
    VR: 1,
    AR: 2
};
